import {ref, reactive, computed} from "@vue/composition-api";
import CompanyService from "@/api/company";
import MessageService from "@/components/Message";
import DepartmentService from "@/api/department";

export const companys = ref([]);
export const depts = ref([]);
export const type = ref('');
export const loading = ref(true);
export const search = ref('');
export const dialogVisible = ref(false);
export const dept = ref(false);

export const company = ref({
    companyName: undefined,
    companyId: undefined,
    companyNo: undefined,
    departmentNo: undefined,
});

export const dialogTitle = computed(() => {

    const titleMapper = {
        add: "新增用戶",
        update: "修改用戶資料"
    };

    return titleMapper[type.value];
})

export const columns = reactive([
    {label: "公司代碼", prop: "companyNo"},
    {label: "公司名稱", prop: "companyName"},
    {label: "統一編號", prop: "companyId"},
    {label: "部門代碼", prop: "departmentNo"}
])

export const openDialog = (row, newType, newDept) => {
    company.value = row;
    type.value = newType;
    dept.value = newDept;
    if (dept.value) {
        company.value.departmentNo = dept.value;
    }

    dialogVisible.value = true;
}

export const handleClose = () => dialogVisible.value = false;

export const add = company => {

    CompanyService.add(company)
        .then(data => {
            companys.value.unshift(data);
            dialogVisible.value = false;

            MessageService.success(`成功新增：${data.companyNo}-${data.departmentNo}`)
        })
        .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
}

export const update = company => {

    CompanyService.update(company)
        .then(data => {
            const index = companys.value.findIndex(comp => comp.id === company.id);
            companys.value.splice(index, 1, data)
            dialogVisible.value = false;
            MessageService.success(`成功新增：${data.companyNo}-${data.departmentNo}`)
        })
        .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
}

export const del = row => {

    const id = row.id

    CompanyService.deleteById(id)
        .then(() => {
            const index = companys.value.findIndex(comp => comp.id === id);
            // 利用 arr.splice(startIndex, deleteCount)
            companys.value.splice(index, 1);
            MessageService.success(`成功刪除：${row.companyNo}-${row.departmentNo}`)
        })
        .catch(e => MessageService.error(`錯誤提示：${e.title} , ${e.message}`));
}

export const init = async () => {
    companys.value = await CompanyService.list();
    depts.value = await DepartmentService.list();
    loading.value = false;
}

export const findByCompanyId = () => {
    if (companys) {
        const temp = companys.value.find(comp => comp.companyId === company.value.companyId);
        if (temp) {
            company.value.companyName = temp.companyName;
            company.value.companyNo = temp.companyNo;
        } else {
            MessageService.success(`${company.value.companyId} 查無資料`)
        }
    }   
}
